import { mapMutations, mapState } from 'vuex';

export default {
  props: {},
  data: function () {
    return {
      toBeCheckedPaths: [],
      toPublishPaths: [],
      showProgressDialog: false,
      waiting: false,
      progress: 0,
      maxIntervalWaitingTime: 30
    };
  },
  computed: {
    ...mapState({
      models: 'models',
      language: 'selectedLanguage',
      awsExports: 'awsExports',
      sdk: 'sdk'
    })
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'setSnackbar',
      setViewReload: 'setViewReload'
    }),
    async publishByPaths(paths) {
      try {
        this.waiting = true;
        this.toBeCheckedPaths = [];
        this.progress = 0;
        // [...new Set(paths)] is using to made the list unique
        const records = await this.getRecordsByPaths([...new Set(paths)]);
        if (!records) throw new Error('wrong response from DB');
        this.toPublishPaths = records.reduce((list, record) => {
          if (this.isRecordNotPublish(record)) {
            list.push({
              path: this.sdk.getDataRootPath(record.model, record.slug, this.language),
              versionId: record.version
            });
          }
          return list;
        }, []);
        if (this.toPublishPaths.length) {
          this.showProgressDialog = true;
          // publish all selected Files
          await Promise.all(this.toPublishPaths.map((item) => this.publishByPath(item.path, item.versionId)))
            .then(() => {
              this.toBeCheckedPaths = this.toPublishPaths.map((item) => item.path);
              this.checkIsPublished();
            })
            .catch((reason) => {
              console.error(reason);
              this.showProgressDialog = false;
              this.setSnackbar({ message: this.$t('publisher.error'), type: 'error' });
            });
        } else {
          this.setSnackbar({ message: this.$t('publisher.nothing'), type: 'warning' });
          this.showProgressDialog = false;
        }
      } catch (e) {
        this.showProgressDialog = false;
        console.error('e', e);
        this.setSnackbar({ message: this.$t('publisher.error'), type: 'error' });
      }
      this.waiting = false;
    },
    checkIsPublished(interval = 1) {
      const waitingTime = this.fibonacci(interval);
      setTimeout(async () => {
        // look which slugs must be check again
        this.toBeCheckedPaths = await this.getNotPublishedPathsFromDB(this.toBeCheckedPaths);
        this.progress =
          (100 / this.toPublishPaths.length) * (this.toPublishPaths.length - this.toBeCheckedPaths.length);

        // checking is list from not published files empty
        if (!this.toBeCheckedPaths.length) {
          this.progress = 100;
          setTimeout(async () => {
            await this.$nextTick();
            this.showProgressDialog = false;
            this.setViewReload(true);
          }, 1000);
          // break loop when waiting to long
        } else if (waitingTime >= this.maxIntervalWaitingTime) {
          this.showProgressDialog = false;
          this.setSnackbar({ message: this.$t('publisher.error'), type: 'error' });
        } else {
          //TODO needs a better algorithms to higher the waiting time
          this.checkIsPublished(interval + 1);
        }
      }, waitingTime * 1000);
    },
    fibonacci(num, memo) {
      memo = memo || {};
      if (memo[num]) return memo[num];
      if (num <= 1) return 1;
      return (memo[num] = this.fibonacci(num - 1, memo) + this.fibonacci(num - 2, memo));
    },
    async getNotPublishedPathsFromDB(paths) {
      const records = await this.getRecordsByPaths(paths);
      // return only paths, there current save versiomn is not published
      return this.getNotPublishedPathsByRecords(records);
    },
    getNotPublishedPathsByRecords(records) {
      return records.reduce((list, record) => {
        if (this.isRecordNotPublish(record)) {
          const toPublishPath = this.sdk.getDataRootPath(
            this.sdk.getDatatypeFromPath(record.filename),
            this.sdk.getSlugFromPath(record.filename),
            this.language
          );
          return [...list, toPublishPath];
        }
        return list;
      }, []);
    },
    isRecordNotPublish(record) {
      const currentFileVersion = record?.version;
      const currentPublishVersion = record?.destinationmetadata?.tags?.find((tag) => tag.Key === 'srcVersionId')?.Value;
      return currentFileVersion !== currentPublishVersion || !currentPublishVersion;
    },
    getRecordsByPaths(paths) {
      return this.sdk
        .getDocuments({
          language: this.language,
          limit: 1000,
          destinationBucket: this.awsExports.Storage.AWSS3.publishedBucket,
          filenames: paths.map((path) => `${path}/index.json`),
          fields: ['filename', 'model', 'slug', 'data', 'resolved_data', 'version', 'metadata']
        })
        .then((response) => response?.records);
    },
    publishByPath(path, currentFileVersion) {
      const datatype = this.$store.state.sdk.getDatatypeFromPath(path);
      const slug = this.$store.state.sdk.getSlugFromPath(path);
      const language = this.$store.state.sdk.getLanguageFromPath(path);
      // send trigger message on sqs for publish
      return this.$store.state.sdk.publishObject(
        this.awsExports.Storage.AWSS3.unpublishedBucket,
        this.awsExports.Storage.AWSS3.publishedBucket,
        datatype,
        slug,
        language,
        currentFileVersion
      );
    }
  }
};
